const UrgentRequestConfirm = () => {
  return <div>Urgent Request Confirm</div>;
};

export default UrgentRequestConfirm;
